export enum ClientChoreInitiatedVia {
  submission = 'submission',
  clientConfigurationUpdate = 'client_configuration_update',
  clientUpdate = 'client_update',
  patientInteractionLocationUpdate = 'patient_interaction_location_update',
  clientEncounterTypeEligibilityUpdate = 'client_encounter_type_eligibility_update',
}
